import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { QRPreferences } from "src/models/qr-preferences";

import { CustomerService } from "src/services/customer.service";

@Component({
  selector: "app-referral-qr",
  templateUrl: "./referral-qr.component.html",
  styleUrls: ["./referral-qr.component.css"],
})
export class ReferralQrComponent implements OnInit {
  isLoading = true;
  isSaving = false;
  previousPreferences: QRPreferences | null = null;

  constructor(
    private customer: CustomerService,
    private diloag: MatDialog,
    private _snackbar: MatSnackBar,
  ) {}

  pageTitle = "Referral QR Code";

  qrPreferenceForm = new FormGroup({
    careplusQR: new FormControl<boolean>({ value: false, disabled: true }),
    comprehensiveQR: new FormControl<boolean>({ value: false, disabled: true }),
    safrattiQR: new FormControl<boolean>({ value: false, disabled: true }),
    saiyartiQR: new FormControl<boolean>({ value: false, disabled: true }),
  });

  ngOnInit() {
    this.getQrPreferences();
  }

  getQrPreferences() {
    this.isLoading = true;
    this.customer.getQrConfig().subscribe(
      (res: QRPreferences) => {
        this.isLoading = false;
        if (res) {
          this.previousPreferences = res;
          this.qrPreferenceForm.patchValue(
            {
              careplusQR: res.careplusQR,
              comprehensiveQR: res.comprehensiveQR,
              safrattiQR: res.safrattiQR,
              saiyartiQR: res.saiyartiQR,
            },
            { emitEvent: false },
          );
          this.qrPreferenceForm.markAsPristine();
          this.qrPreferenceForm.enable();
        }
      },
      (error) => {
        this.isLoading = false;
      },
    );
  }

  cancelChanges() {
    if (this.previousPreferences) {
      this.qrPreferenceForm.patchValue(this.previousPreferences, { emitEvent: false });
      this.qrPreferenceForm.markAsPristine();
    } else {
      this.getQrPreferences();
    }
    this._snackbar.open("Changes discarded for QR Preferences.", "Close", {
      duration: 3000,
    });
  }

  updateQrConfig() {
    this.isSaving = true;
    const body = this.qrPreferenceForm.value;
    this.customer.toggleQrConfig(body as QRPreferences).subscribe(
      () => {
        this.isSaving = false;
        this.previousPreferences = body as QRPreferences;
        this.qrPreferenceForm.markAsPristine();
        this._snackbar.open("QR Preferences Updated Successfully.", "Close", {
          duration: 3000,
        });
      },
      (error) => {
        this.isSaving = false;
        if (this.previousPreferences) {
          this.qrPreferenceForm.patchValue(this.previousPreferences, { emitEvent: false });
          this.qrPreferenceForm.markAsPristine();
        }
        this._snackbar.open("Failed to update preferences.", "Close", {
          duration: 3000,
        });
      },
    );
  }
}
